import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c93ae10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gifs-selection" }
const _hoisted_2 = { class: "gifs-container" }

import SearchBar from "@/components/forms/SearchBar/SearchBar.vue";
import GifItem from "../GifItem/GifItem.vue";
import { fetchTenorApi } from "@/plugins";
import { TenorDisplayObject, TenorResultsObject } from "@/types/gifs";
import { onMounted, Ref, ref } from "vue";
import { useI18n } from "vue-i18n";

interface Emits {
  (e: "insert-gif", url: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GifsSelection',
  emits: ["insert-gif"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const searchData = ref<TenorDisplayObject[]>([]);
const featuredData = ref<TenorDisplayObject[]>([]);
const { locale, t } = useI18n();

const insertGif = (url: string) => {
  emit("insert-gif", url);
};

const getTenorDisplayObjects = (
  data: TenorResultsObject,
): TenorDisplayObject[] =>
  data.results.map(({ content_description, media_formats }) => ({
    description: content_description,
    url: media_formats.gif.url,
  }));

const fetchFeaturedGifs = async () => {
  const { data } = await fetchTenorApi("featured", { locale: locale.value });
  saveData(data, featuredData);
  saveData(data, searchData);
};

const saveData = (data: TenorResultsObject, ref: Ref<TenorDisplayObject[]>) => {
  const results = getTenorDisplayObjects(data);
  ref.value = results;
};

const searchGifs = async (searchText: string) => {
  if (!searchText) {
    searchData.value = { ...featuredData.value };
    return;
  }
  const { data } = await fetchTenorApi("search", {
    q: searchText,
    locale: locale.value,
  });
  saveData(data, searchData);
};

onMounted(() => {
  fetchFeaturedGifs();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SearchBar, {
      placeholder: _unref(t)('forms.searchTenor'),
      onSearch: searchGifs
    }, null, 8, ["placeholder"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchData.value, ({ description, url }) => {
        return (_openBlock(), _createBlock(GifItem, {
          key: url,
          description: description,
          url: url,
          onInsertGif: insertGif
        }, null, 8, ["description", "url"]))
      }), 128))
    ])
  ]))
}
}

})